import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import morph from '@alpinejs/morph'
import focus from '@alpinejs/focus'
import persist from '@alpinejs/persist'
import intersect from '@alpinejs/intersect'
import './components/iframe-auto-size';
import './components/gallery';
import './components/carousel';
import './components/tooltips';
import './components/weather_tabs';
import {
    initializePowderguide,
    killOldServiceWorkers,
} from "./api";
import {Linkify} from "./linkify";
import {initializeVideoPlayer} from './video-player';
import {addTokenToLink} from './token';
import {initChoices} from './choices';

// Global get CSRF token function (used by forms).
window.getToken = async () => {
    return await fetch('/!/statamic-peak-tools/dynamic-token/refresh')
        .then((res) => res.json())
        .then((data) => {
            return data.csrf_token
        })
        .catch((error) => {
            this.error = 'Something went wrong. Please try again later.'
        })
}

function initialize() {
    killOldServiceWorkers();
    const {
        tokenStorage,
        powderguideApi,
        powderguideAuthentication,
        powderguideComments,
        powderguideRegistration,
        powderguidePasswordReset,
        powderguideArticles,
        powderguideEvents,
        powderguideConditionsReports,
        dateFormatter,
    } = initializePowderguide(Alpine);
    const linkify = new Linkify();

    // Call Alpine.
    window.Alpine = Alpine
    Alpine.plugin(collapse)
    Alpine.plugin(morph)
    Alpine.plugin(focus)
    Alpine.plugin(persist)
    Alpine.plugin(intersect)
    Alpine.directive('linkify', el => linkify.parseFromDomNode(el))
    Alpine.directive('powderguide-add-token', el => addTokenToLink(el, tokenStorage))
    Alpine.directive('choices', (...args) => initChoices(...args))
    Alpine.store('powderguideApiAuthentication', powderguideAuthentication)
    Alpine.store('powderguideApi', powderguideApi)
    Alpine.store('powderguideComments', powderguideComments)
    Alpine.store('powderguideRegistration', powderguideRegistration)
    Alpine.store('powderguidePasswordReset', powderguidePasswordReset)
    Alpine.store('powderguideArticles', powderguideArticles)
    Alpine.store('powderguideEvents', powderguideEvents)
    Alpine.store('powderguideConditionsReports', powderguideConditionsReports)
    Alpine.store('dateFormatter', dateFormatter)

    Alpine.start();

    for (const video of document.querySelectorAll('[data-video\\.wrapper]')) {
        initializeVideoPlayer(video);
    }

    for (const link of document.querySelectorAll('a[data-powderguide-add-token]')) {
        addTokenToLink(link, tokenStorage);
    }
}

const isStaticCache = document.querySelector('[data-nocache]') !== null;
if (isStaticCache) {
    document.addEventListener('statamic:nocache.replaced', () => initialize())
} else {
    initialize();
}
